import { MapPin, Mail, Phone, Crosshair } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
export default function TheCoordinates() {
  return <section data-section-id="223105" id="visit-our-shop" className="relative w-full min-h-[600px] md:min-h-[700px] bg-primary text-primary-foreground flex items-center overflow-hidden border-t-4 border-destructive">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673119/img/kimball_shop_map_overlay.png)] bg-cover bg-center opacity-40 mix-blend-overlay grayscale" />
        
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-primary via-primary/90 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-primary via-transparent to-transparent" />

        {}
        <div className="absolute top-1/2 left-[100%] md:left-[70%] -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
          {}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-24 h-24 rounded-lg border border-destructive/30 animate-[ping_3s_cubic-bezier(0,0,0.2,1)_infinite]" />
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-16 h-16 rounded-lg border border-destructive/40 animate-[ping_2s_cubic-bezier(0,0,0.2,1)_infinite_1s]" />
          </div>
          
          {}
          <div className="relative z-10 w-12 h-12 rounded-md bg-primary/80 backdrop-blur-sm flex items-center justify-center border border-destructive shadow-lg shadow-destructive/20">
            <Crosshair className="w-6 h-6 text-destructive" />
          </div>
          
          {}
          <div className="w-[2px] h-8 bg-gradient-to-b from-destructive to-transparent mt-1" />
          
          {}
          <div className="w-2 h-2 bg-destructive rounded-sm shadow-sm shadow-destructive mt-1" />
        </div>
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="max-w-full md:max-w-md">
          <Card className="bg-primary/40 backdrop-blur-md border-white/10 shadow-2xl overflow-hidden relative rounded-md">
            {}
            <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-destructive to-transparent opacity-90" />
            
            {}
            <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-destructive/50 rounded-tl-md" />
            <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-destructive/50 rounded-tr-md" />
            <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-destructive/50 rounded-bl-md" />
            <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-destructive/50 rounded-br-md" />

            <CardHeader className="pb-6 md:pb-8">
              <CardTitle className="text-3xl font-default tracking-tighter text-white uppercase font-black">
                Command Center
              </CardTitle>
              <CardDescription className="text-destructive font-mono text-sm uppercase tracking-widest mt-2 font-bold">
                Kimball Speedy Lube
              </CardDescription>
            </CardHeader>
            
            <CardContent className="space-y-6 md:space-y-8">
              {}
              <div className="group flex items-start gap-5">
                <div className="mt-1 p-2.5 rounded-sm bg-destructive/10 border border-destructive/20 text-destructive transition-colors group-hover:bg-destructive/20 group-hover:border-destructive/40">
                  <MapPin className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="text-xs font-mono text-white/60 uppercase tracking-widest mb-1.5">
                    Service Bay Location
                  </h3>
                  <p className="text-base font-default text-white leading-relaxed">
                    837 Kimball Crossing Dr<br />
                    Jasper, TN 37347
                  </p>
                </div>
              </div>

              {}
              <div className="group flex items-start gap-5">
                <div className="mt-1 p-2.5 rounded-sm bg-destructive/10 border border-destructive/20 text-destructive transition-colors group-hover:bg-destructive/20 group-hover:border-destructive/40">
                  <Mail className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="text-xs font-mono text-white/60 uppercase tracking-widest mb-1.5">
                    Digital Support
                  </h3>
                  <Link to="#" className="text-base font-default text-white hover:text-destructive transition-colors inline-block">
                    service@kimballspeedylube.com
                  </Link>
                </div>
              </div>

              {}
              <div className="group flex items-start gap-5">
                <div className="mt-1 p-2.5 rounded-sm bg-destructive/10 border border-destructive/20 text-destructive transition-colors group-hover:bg-destructive/20 group-hover:border-destructive/40">
                  <Phone className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="text-xs font-mono text-white/60 uppercase tracking-widest mb-1.5">
                    Direct Line
                  </h3>
                  <Link to="tel:+14238371807" className="text-base font-default text-white hover:text-destructive transition-colors inline-block">
                    (423) 837-1807
                  </Link>
                </div>
              </div>
            </CardContent>

            <CardFooter className="pt-4 pb-6 md:pb-8">
              <Button className="w-full font-mono uppercase tracking-widest text-xs h-12 border-destructive/40 text-white hover:border-destructive hover:bg-destructive hover:text-white transition-all duration-300 rounded-sm" variant="outline">
                Get Service Directions
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}